import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Single source of truth for className composition.
 *
 * `twMerge` is the part that matters: it resolves Tailwind conflicts by
 * precedence rather than by string order, so a caller's `className="px-6"`
 * actually replaces a component's built-in `px-4` instead of both landing in
 * the class list and letting stylesheet order pick the winner.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type { ClassValue } from "clsx";
